import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_infogroup_edition = _resolveComponent("infogroup-edition")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mandatoryFieldsLayout, (key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key.infogroupType
    }, [
      _createVNode(_component_infogroup_edition, {
        "info-group": key,
        "info-group-data": _ctx.infogroupDataMap.get(key),
        "onUpdate:infoGroupData": ($event: any) => (_ctx.updateInfogroupDataMap(key, $event)),
        mandatory: ""
      }, null, 8, ["info-group", "info-group-data", "onUpdate:infoGroupData"])
    ]))
  }), 128))
}